<template>
    <div class='c-pager'>
        <a v-if="pagerInfo.currentPage>1" @click.prevent="goToPage(pagerInfo.currentPage -= 1)" href="#" class='c-pager__prev' :aria-label="t('Aller à la page précédente')">
            <svg class="o-ico -ico-arrow-full-left" role="img">
                <title>arrow-full-left</title>
                <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-left"></use>
            </svg>
            <span class="sr-only">
                {{ t("Aller à la page précédente") }}
            </span>
        </a>
        <a v-if="pagerInfo.currentPage>3" @click.prevent="goToPage(pagerInfo.currentPage = 1)" class='c-pager__number' href='#' :aria-label="t('Aller à la page')+' : 1'">
            {{ 1 }}
            <span class="sr-only">
                {{ t("Aller à la page") }} : 1
            </span>
        </a>
        <span v-if="pagerInfo.currentPage>4" class="c-pager__separator">...</span>
        <template v-if="getPrevPages(2)">
            <a v-for="number in getPrevPages(2)" @click.prevent="goToPage(pagerInfo.currentPage = number)" class='c-pager__number' href='#' :aria-label='t("Aller à la page")+" : "+ number'>
                {{ number }}
                <span class="sr-only">
                    {{ t("Aller à la page") }} : {{ number }}
                </span>
            </a>
        </template>
        <span class='c-pager__number -current'>
            {{ pagerInfo.currentPage }}
            <span class="sr-only">
                {{ t("Vous êtes actuellement sur cette page") }}
            </span>
        </span>
        <template v-if="getNextPages(2)">
            <a v-for="number in getNextPages(2)" @click.prevent="goToPage(pagerInfo.currentPage = number)" class='c-pager__number' href='#' :aria-label='t("Aller à la page")+" : "+ number'>
                {{ number }}
                <span class="sr-only">
                    {{ t("Aller à la page") }} : {{ number }}
                </span>
            </a>
        </template>
        <span v-if="pagerInfo.currentPage < pagerInfo.totalPages-3" class="c-pager__separator">...</span>
        <a v-if="pagerInfo.currentPage < pagerInfo.totalPages-2" @click.prevent="goToPage(pagerInfo.currentPage = pagerInfo.totalPages)" class='c-pager__number' href='#' :aria-label='t("Aller à la page")+" : "+ pagerInfo.totalPages'>
            {{ pagerInfo.totalPages }}
            <span class="sr-only">
                {{ t("Aller à la page") }} : {{ pagerInfo.totalPages }}
            </span>
        </a>
        <a v-if="pagerInfo.currentPage<pagerInfo.totalPages" @click.prevent="goToPage(pagerInfo.currentPage += 1)" href='#' class='c-pager__next' :aria-label="t('Aller à la page suivante')">
            <svg class="o-ico -ico-arrow-full-left" role="img">
                <title>arrow-full-left</title>
                <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-left"></use>
            </svg>
            <span class="sr-only">
                {{ t("Aller à la page suivante") }}
            </span>
        </a>
    </div>
</template>

<script>
    export default {
        name: 'Pager',
        props: {
            pagerInfo: {
                type: Object,
                required: true
            }
        },
        mounted() {
            //console.log(this.pagerInfo);
        },
        methods: {
            t(string) {
                return PagerLocalisation[string];
            },
            goToPage(page) {
                this.$emit('goToPage', page);
            },
            getPrevPages(nbPages) {
                let pages = [];
                for (let i = this.pagerInfo.currentPage - nbPages; i < this.pagerInfo.currentPage; i++) {
                    if (i > 0) {
                        pages.push(i);
                    }
                }
                return pages;
            },
            getNextPages(nbPages) {
                let pages = [];
                for (let i = this.pagerInfo.currentPage + 1; i <= this.pagerInfo.currentPage + nbPages; i++) {
                    if (i <= this.pagerInfo.totalPages) {
                        pages.push(i);
                    }
                }
                return pages;
            }
        }
    }
</script>